export enum QuestionType {
     SingleChoice,
     Text,
     MultipleChoice
}